var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSshKeysHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/left-sidebar/ic ssh keys",
    clipPath: "url(#clip0_9146_76194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic key",
    clipPath: "url(#clip1_9146_76194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.3362 0.664062C8.46965 0.664062 5.33496 3.79876 5.33496 7.66531C5.33496 11.5319 8.46965 14.6666 12.3362 14.6666C16.2028 14.6666 19.3375 11.5319 19.3375 7.66531C19.3375 3.79876 16.2028 0.664062 12.3362 0.664062ZM14.67 7.19856C13.6384 7.19856 12.803 6.36308 12.803 5.33156C12.803 4.30005 13.6384 3.46456 14.67 3.46456C15.7015 3.46456 16.537 4.30005 16.537 5.33156C16.537 6.36308 15.7015 7.19856 14.67 7.19856Z",
    fill: "#2894FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.88246 10.3828L0.940508 15.3248C0.76501 15.5003 0.666992 15.7374 0.666992 15.9847V18.3988C0.666992 18.9141 1.0852 19.3323 1.60049 19.3323H4.01452C4.2619 19.3323 4.49994 19.2343 4.67451 19.0588L5.88152 17.8517C6.1289 17.6044 6.26799 17.2683 6.26799 16.9182C6.26799 16.1892 6.8589 15.5983 7.58796 15.5983C7.93802 15.5983 8.27408 15.4592 8.52146 15.2118L9.61646 14.1168C7.93616 13.4083 6.59098 12.0622 5.88246 10.3828Z",
    fill: "#BFDFFF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9146_76194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9146_76194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSshKeysHover);
export default __webpack_public_path__ + "static/media/ssh-keys-hover.89b2708517cc83fbb785003bbd0a4f35.svg";
export { ForwardRef as ReactComponent };